module.exports = __webpack_public_path__ + "static/img/bo.5f9d3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/bo.png
// module id = ntgR
// module chunks = 18